import Layout from "soapbox/components/ui/layout.tsx";
import LinkFooter from "soapbox/features/ui/components/link-footer.tsx";
import {
  TrendsPanel,
  SignUpPanel,
  CtaBanner,
  WhoToFollowPanel,
  AdsPanel,
} from "soapbox/features/ui/util/async-components.ts";
import { useAppSelector } from "soapbox/hooks/useAppSelector.ts";
import { useFeatures } from "soapbox/hooks/useFeatures.ts";

interface ILandingPage {
  children: React.ReactNode;
}

const LandingPage: React.FC<ILandingPage> = ({ children }) => {
  const me = useAppSelector((state) => state.me);
  const features = useFeatures();

  return (
    <>
      <Layout.Main className="space-y-3 pt-3 dark:divide-gray-800 sm:pt-0">
        {children}

        {!me && <CtaBanner />}
      </Layout.Main>

      <Layout.Aside>
        {!me && <SignUpPanel />}
        {features.trends && <TrendsPanel limit={5} />}
        {features.suggestions && <WhoToFollowPanel limit={3} />}
        <AdsPanel />
        <LinkFooter />
      </Layout.Aside>
    </>
  );
};

export default LandingPage;
